<template>
  <v-app v-if="isUserLoggedIn">
    <v-navigation-drawer app fixed clipped v-model="showSideMenu">
      <v-toolbar flat>
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <img :src="user.avatar ? user.avatar : ''" :alt="user.fullname"/>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title @click="showContactsForm()">{{ user.fullname }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider></v-divider>
      <router-view name="menu"></router-view>
    </v-navigation-drawer>

    <v-toolbar app clipped-left>
      <v-toolbar-side-icon @click="showSideMenu = !showSideMenu"></v-toolbar-side-icon>
      <v-toolbar-title class="headline text-uppercase">
        <!--        <span>КРУ&nbsp;</span>-->
        <span class="font-weight-light">{{
            $t('name')
          }} <small><small><small>Версия: 1.8.3 (29/03/2023)</small></small></small></span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="isUserAdmin" flat :to="{ name: 'admin' }">{{ $t('menu.admin') }}</v-btn>
      <v-btn v-if="isUserManager || isUserHead" flat :to="{ name: 'reports' }">{{ $t('menu.reports') }}</v-btn>
      <v-btn v-if="isUserAdmin || isUserManager || isUserHead || isUserConfigurator" flat :to="{ name: 'home' }"
             :exact="true">{{ $t('menu.main') }}
      </v-btn>
      <v-btn v-if="isUserAdmin || isUserConfigurator" flat :to="{ name: 'config' }" :exact="true">{{
          $t('menu.config')
        }}
      </v-btn>

      <v-btn flat @click="signOut">{{ $t('menu.logout') }}</v-btn>

      <locale-switcher/>
    </v-toolbar>

    <v-content>
      <router-view/>
    </v-content>

    <v-dialog v-model="confirmation.show" persistent lazy :max-width="400">
      <v-card>
        <v-card-title>
          <span class="headline">{{ confirmation.title || $t('confirmation.title') }}</span>
        </v-card-title>
        <v-card-text>
          <div v-html="confirmation.message"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat color="default" @click="confirmation.show = false">{{ $t('confirmation.cancel') }}</v-btn>
          <v-btn flat color="primary" @click="confirmed">{{ $t('confirmation.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isContactsFormVisible" persistent lazy :max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('contacts.title') }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <h4 style="margin-bottom: 1rem;">{{ $t('contacts.message') }}</h4>
            </v-flex>
            <v-flex xs12>
              <v-text-field :label="$t('contacts.email')" required v-model="contacts.email" :counter="255"/>
            </v-flex>
            <v-flex xs12>
              <v-text-field :label="$t('contacts.phone')" required v-model="contacts.phone" :counter="255"/>
            </v-flex>
            <v-flex xs12>
              <v-text-field :label="$t('contacts.mobile')" required v-model="contacts.mobile" :counter="16" />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
<!--          <v-btn flat color="default" @click="isContactsFormVisible = false">{{ $t('contacts.cancel') }}</v-btn>-->
          <v-btn flat color="primary" @click="saveContactsData()" :disabled="contacts.mobile.length > 16">{{ $t('contacts.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="notification.show" :timeout="5000" :top="true" :color="notification.type || 'info'">
      {{ notification.message }}
      <v-btn flat @click="notification.show = false">{{ $t('notification.close') }}</v-btn>
    </v-snackbar>
  </v-app>
  <login-form v-else/>
</template>

<script>
import { mapState } from 'vuex'

import LoginForm from './components/LoginForm'
import LocaleSwitcher from "@/components/LocaleSwitcher";

import { SET_TOKEN } from './store'

export default {
  name: 'App',
  components: {
    LoginForm,
    LocaleSwitcher
  },
  data: () => ({
    notification: {
      show: false,
      message: '',
      type: 'info',
    },
    confirmation: {
      show: false,
      title: '',
      message: '',
      action: null,
    },
    contacts: {
      email: '',
      phone: '',
      mobile: '',
    },

    isContactsFormVisible: false,

    showSideMenu: true,

    timer: null
  }),
  computed: {
    ...mapState([
      'user'
    ]),
    isUserLoggedIn() {
      return this.$store.getters.isUserLoggedIn
    },
    isUserAdmin() {
      return this.$store.getters.isUserAdmin
    },
    isUserManager() {
      return this.$store.getters.isUserManager
    },
    isUserHead() {
      return this.$store.getters.isUserHead
    },
    isUserConfigurator() {
      return this.$store.getters.isUserConfigurator
    }
  },
  created() {
    this.checkAuth()
    this.checkLocale()
    this.$events.$on('notify', ({ message, type }) => {
      this.notification.message = message
      this.notification.type = type || 'info'
      this.notification.show = true
    })
    this.$events.$on('confirm', ({ title, message, action }) => {
      this.confirmation.title = title || this.$t('confirmation.title')
      this.confirmation.message = message || this.$t('confirmation.message')
      this.confirmation.action = action || null
      this.confirmation.show = true
    })

    this.$events.$on('authenticated', async (user) => {
      await this.refreshUserInfo(user)
      this.showContactsForm()
    })

    this.$events.$on('contacts', () => {
      this.isContactsFormVisible = true
    })
  },
  mounted() {
    document.title = `${this.$t('title')}`

    if (this.isUserLoggedIn) {
      this.refreshUserInfo({ id: this.$cookie.get('x-user-id') })
        .then(() => {
          const updatedAt = new Date(this.user["updated_at"]);
          if ((updatedAt.getTime() + 604800000) < Date.now()) {
            this.showContactsForm()
          }
        })
    }
  },
  methods: {
    checkAuth() {
      const token = this.$cookie.get('x-auth-token')
      if (token) {
        this.$store.commit(SET_TOKEN, token)
      }
    },
    checkLocale() {
      this.$i18n.locale = localStorage.getItem('rating-locale') || 'ru'
    },
    refreshUserInfo(user) {
      user = user || this.user
      return this.$store.dispatch('getUserInfo', user)
          .then(() => {
            this.timer = setTimeout(this.refreshUserInfo, 50000)
          }).catch((e) => {
            console.error(e)
            this.signOut()
          })
    },
    signOut() {
      this.$store.dispatch('signOut')
      this.$cookie.delete('x-auth-token')
      this.$cookie.delete('x-user-id')
      this.$router.push({ name: 'home' })
      if (this.timer) {
        clearTimeout(this.timer)
      }
    },
    confirmed() {
      if (this.confirmation.action) {
        this.confirmation.action()
      }

      this.confirmation.show = false
    },
    showContactsForm() {
      this.contacts.email = this.user.email
      this.contacts.phone = this.user.phone
      this.contacts.mobile = this.user.mobile

      this.isContactsFormVisible = true
    },
    saveContactsData() {
      this.$store.dispatch('saveUserContacts', this.contacts)
        .then(() => {
          console.log('contacts saved')
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.isContactsFormVisible = false
        })
    }
  },
}
</script>
